import { render, staticRenderFns } from "./withholdIntegral.vue?vue&type=template&id=088ac1f2&scoped=true"
import script from "./withholdIntegral.vue?vue&type=script&lang=js"
export * from "./withholdIntegral.vue?vue&type=script&lang=js"
import style0 from "./withholdIntegral.vue?vue&type=style&index=0&id=088ac1f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088ac1f2",
  null
  
)

export default component.exports